import { combineReducers } from 'redux';
import appInfoReducer from './AppInfo';

// reducers
const appReducer = combineReducers({
  info: appInfoReducer,
});

export default appReducer;
